import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
const SMSCountDown = ({
  showOtpModal,
  resendOtp,
  onHide,
  counterSms,
  setCounterSMS,
}) => {
  useEffect(() => {
    counterSms > 0 && setTimeout(() => setCounterSMS(counterSms - 1), 1000);
  }, [showOtpModal ? counterSms : null]);

  function getMinAndSec(seconds) {
    const min = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return (
      min.toString().padStart(2, '0') + ':' + secs.toString().padStart(2, '0')
    );
  }

  const countDown = getMinAndSec(counterSms);

  return (
    <>
      {counterSms === 0 ? (
        <>
          <>
            <p class="text-left">
              Didn't receive code?
              <Button
                onClick={resendOtp}
                variant="link"
                style={{ color: 'blue', padding: '3px', marginTop: '-5px' }}
              >
                Resend
              </Button>
            </p>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp;
            <Button variant="info" className="text-white" onClick={onHide}>
              Close
            </Button>
          </>
        </>
      ) : (
        <>
          {' '}
          <p class="text-center">
            Please wait for the remaining time to resend an OTP :{' '}
            <b> {countDown}</b>
          </p>
        </>
      )}
    </>
  );
};

export default SMSCountDown;
